import React from 'react';
import loadable from '@loadable/component';

const PromoSMSEmailConnectLazy = loadable(
    () => import(/* webpackChunkName: "LazyPromoSMSChunks" */ './PromoSMSConnect'),
    {
        fallback: <div />,
    }
);

export default PromoSMSEmailConnectLazy;
